import { useState, useEffect } from "react";
import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";
import OverFlowTooltipWithTabsMui from "@/component/common/OverFlowTooltipWithTabsMui";
import { MenuItem, Select } from "@material-ui/core";
import { I18n } from "aws-amplify";
import { isDisabledAllFieldCsv } from "../handler/KnowledgeUploadCsvHandler";

function DropDownOptionDelete({
    classes,
    handleStatus,
    
    selectDeleteMode,
    setSelectDeleteMode,
    listMapping,
    
    selectDeleteKey,
    setSelectDeleteKey,
    listFieldInForm,
    
    selectCsvColumnName,
    setSelectCsvColumnName,
    listOptionsKnowledgeId,
}) {

    // const [listDeleteMode, setListDeleteMode] = useState([...listMapping])

    // // handle add more Label: 削除モード
    // useEffect(() => {
    //     let customListDeleteMode = [...listMapping];

    //     if (listMapping.length > 1) {
    //         let index = customListDeleteMode.findIndex(obj => obj.key === 0);
    //         if (index !== -1) {
    //             customListDeleteMode.splice(index + 1, 0,
    //                 {
    //                     key: 'label',
    //                     value: '削除モード'
    //                 }
    //             );
    //         }
    //     }
    //     setListDeleteMode([...customListDeleteMode]);

    // }, [listMapping]);

    const handleChangeSelectDeleteCsvColumn = (e) => {
        let selectedDeleteMode = listMapping.find(item => item.key === e.target.value);
        if (selectedDeleteMode) {
            setSelectDeleteMode({
                ...selectedDeleteMode
            });
    
            if (e.target.value === 0) {
                setSelectDeleteKey({});
                setSelectCsvColumnName({});
            }
        }
    }

    const handleChangeDeleteKey = (e) => {
        let selectedFieldKey = listFieldInForm.find(field => field.id === e.target.value);
        if (selectedFieldKey) {
            setSelectDeleteKey({
                key: e.target.value,
                name: Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    selectedFieldKey.name
                ),
                isTicketId: selectedFieldKey.sysField === 'ticketId'
            });
        }
    }

    const handleChangeSelectMappingCsvColumn = (e) => {
        let mappingCsvColumn = listOptionsKnowledgeId.find(item => item.key === e.target.value);
        if (mappingCsvColumn) {
            setSelectCsvColumnName({
                ...mappingCsvColumn
            });
        }
    }

    return (
        <>
            {/* 'LABEL-DROPDOWN-DELETE-DATA': '削除用CSVカラム指定' */}
            <div className="options-delete-data pt-16">
                <label className="label-upload-csv">{I18n.get('LABEL-DROPDOWN-DELETE-DATA')}</label>
                <Select
                    fullWidth
                    displayEmpty
                    className="form-control form-control--wrap"
                    select
                    disabled={isDisabledAllFieldCsv(handleStatus)}
                    variant="outlined"
                    defaultValue={listMapping[0].key}
                    value={selectDeleteMode?.key}
                    onChange={handleChangeSelectDeleteCsvColumn}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                        },
                        classes: { paper: classes.dropdownStyle },
                        getContentAnchorEl: null
                    }}
                >
                    {listMapping?.map((item, index) => {
                        if (item?.key === 'label') {
                            return (
                                <MenuItem
                                    disable
                                    style={{
                                        fontWeight: "bold",
                                        cursor: 'default',
                                        background: 'none'
                                    }}
                                >
                                    {item.value}
                                </MenuItem>
                            )
                        }
                        return (
                            <MenuItem value={item.key} key={`${item.key}_mapping_${index}`}>
                                <OverFlowTooltipWithTabsMui
                                    value={item.value}
                                    className="mapping-item"
                                />
                            </MenuItem>
                        )
                    })}
                </Select>
            </div>
            
            {/* 'LABEL-DROPDOWN-KEY-FOR-DELETE': '削除用キー' */}
            {selectDeleteMode.key !== 0 && (
                <div className="options-delete-data pt-16">
                    <label className="label-upload-csv">
                        {I18n.get('LABEL-DROPDOWN-KEY-FOR-DELETE')}
                    </label>
                    <Select
                        fullWidth
                        displayEmpty
                        className="form-control form-control--wrap"
                        select
                        disabled={isDisabledAllFieldCsv(handleStatus)}
                        variant="outlined"
                        value={selectDeleteKey?.key}
                        onChange={handleChangeDeleteKey}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            classes: { paper: classes.dropdownStyle },
                            getContentAnchorEl: null
                        }}
                    >
                        {listFieldInForm?.map((item, index) => (
                            <MenuItem
                                value={item.id}
                                key={`${item.id}_deleteField_${index}`}
                            >
                                <OverFlowTooltipWithTabsMui
                                    value={Utils.getTextByLanguage(
                                        Constant.LANGUAGE_TYPE.JP,
                                        item.name
                                    )}
                                    className="mapping-item"
                                />
                            </MenuItem>
                        ))}
                    </Select>
                </div>
            )}

            {/* 'LABEL-DROPDOWN-CSV-COLUMN': 'CSV内のカラム名' */}
            {selectDeleteMode.key !== 0 && (
                <div className="options-delete-data pt-16">
                    <label className="label-upload-csv">
                        {I18n.get('LABEL-DROPDOWN-CSV-COLUMN')}
                    </label>
                    <Select
                        fullWidth
                        displayEmpty
                        className="form-control form-control--wrap"
                        select
                        disabled={isDisabledAllFieldCsv(handleStatus)}
                        variant="outlined"
                        value={selectCsvColumnName?.key}
                        onChange={handleChangeSelectMappingCsvColumn}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            classes: { paper: classes.dropdownStyle },
                            getContentAnchorEl: null
                        }}
                    >
                        {listOptionsKnowledgeId?.map((item, index) => (
                            <MenuItem
                                value={item.key}
                                key={`${item.key}_knowledgeId_${index}`}
                            >
                                <OverFlowTooltipWithTabsMui
                                    value={item.value}
                                    className="mapping-item"
                                />
                            </MenuItem>
                        ))}
                    </Select>
                </div>
            )}
        </>
     );
}

export default DropDownOptionDelete;